module.exports = __webpack_public_path__ + "static/media/Precheck.72a44850.png";